<template>
  <section class="suppliers-filters">
    <div class="section-title">
      <span @click="isOpen = !isOpen">
        {{ $t('suppliers.listing.filters.title') }}
        <font-awesome-icon :icon="isOpen ? 'sort-up' : 'sort-down'" />
      </span>
    </div>
    <div v-show="isOpen">
      <div class="active-inactive-label">
        <TolSelect
          :options="filters"
          :placeholder="$t('suppliers.listing.filters.all')"
          :selected="selectedFilter"
          @change="onFilterChange"
        />
      </div>
    </div>
  </section>
</template>
<script>
import TolSelect from '../../../../../components/TolSelect';
import { SuppliersListingGetters } from '../suppliers-listing.keys';

export default {
  components: {
    TolSelect
  },

  data() {
    return {
      isOpen: false,
      searchFilters: [
        {
          label: 'active',
          value: 'true'
        },
        {
          label: 'inactive',
          value: 'false'
        },
        {
          label: 'both',
          value: 'null'
        }
      ]
    };
  },

  computed: {
    filters() {
      let returnValue = [];
      this.searchFilters.forEach(s => {
        returnValue.push({
          label: this.$t('suppliers.filterPreference.' + s.label),
          value: s.value
        });
      });

      return returnValue;
    },
    selectedFilter() {
      return this.searchFilters.filter(
        e => e.value == this.$store.getters[SuppliersListingGetters.SuppliersActiveInactive]
      );
    }
  },
  methods: {
    onFilterChange(activeInactive) {
      this.$emit('change', activeInactive);
    }
  }
};
</script>
<style lang="scss" scoped>
@import '../../../../../styles/colors.scss';
@import '../../../../../styles/variables.scss';

.suppliers-filters {
  background-color: $background-level-2;
  .section-title {
    font-size: 22px;
    font-weight: bold;
    letter-spacing: -0.22px;
    line-height: 25px;
    margin-bottom: 20px;
    padding: 60px;
    display: flex;
    justify-content: space-between;

    > span {
      cursor: pointer;
    }
  }

  .active-inactive-label {
    display: flex;

    padding-left: 60px;
    padding-bottom: 5px;
  }
  .no-box {
    border: 0;
  }
}
</style>
